import { HiOutlineMagnifyingGlass } from "react-icons/hi2";
import { GoLinkExternal } from "react-icons/go";
import { FiMinus, FiPlus, FiUpload } from "react-icons/fi";
import { IoCheckmark } from "react-icons/io5";
import { HiOutlinePencil } from "react-icons/hi2";
import { Container, Title } from "../styles";
import {
  SearchTableInput,
  StatusDiv,
  HeaderContainer,
  StatsCardsContainer,
  StatsCard,
  StatsCardTitle,
  StatsCardNumber,
  SelectDropdownStyles,
  RoundedTableContainer,
  TitleContainer,
  BreadcrumbText,
  AreaBreadcrumbWithEvent,
  TableTab,
  TabsAndFilterContainer,
  SelectsFilterContainer,
  TopActionButton,
  BtnInfo,
} from "./styles";

import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { refreshUserPermissions } from "../../../redux/modules/auth/actions";
import { notification, Tooltip } from "antd";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import AnimatedMainContainer from "../../../components/AnimatedMainContainer";
import { FormattedMessage, useIntl } from "react-intl";
import QuickPreviewModal from "../components/QuickPreviewModal";
import RejectDocumentModal from "../components/RejectDocumentModal";
import EventSelectionModal from "../components/EventSelectionModal";
import Table from "../../../components/Table";
import ButtonOpenPreview from "../../../components/ButtonOpenPreview";
import useDocumentCounters from "../../../hooks/useDocumentCounters";
import api from "../../../service";
import {
  getReportFilterEventsByYearService,
  getReportFilterYearsService,
} from "../../../service/reportFilter.service";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import { BsInfoCircle } from "react-icons/bs";
import SelectWithInternalLabel from "../../../newUXComponents/SelectWithInternalLabel";
import {
  fetchPackageInternalDocuments,
  getDispensedDocumentsService,
  getDocumentConfigsService,
  getDocumentCountersService,
  getDocumentResendHistory,
  getEventDocumentsService,
  getNotDispensedDocumentsService,
  postDispenseStatusService,
} from "../../../service/uploadFlow.service";
import ConfirmationModal from "../../../components/ConfirmationModal";
import AdminSendFileModal from "../components/AdminSendFileModal";

dayjs.extend(customParseFormat);
dayjs.extend(utc);

const ApprovalDocuments = () => {
  const [justificationForLog, setJustificationForLog] = useState("");
  const initialStateObjectDocument = {
    id: 0,
    urlForDownload: "",
    urlForView: "",
    title: "",
    subtitle: "",
    dateText: "",
    status: "",
    justification: "",
    observation: "",
    items: [],
    rejectionReason: null,
    flowName: "",
  };
  const { token, user, permission } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const isStaff = user?.role?.type === "STAFF";
  const hasPermissionToDeleteOwnDocuments = permission.includes(
    "STAFF_DELETE_UPLOADED_DOCUMENTS"
  );

  // Função para recarregar permissões do usuário
  const refreshPermissions = useCallback(async () => {
    if (!token) return;

    try {
      // Buscar permissões atualizadas do usuário
      const response = await api.get("/users/permissions", {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      // Atualizar permissões no Redux
      if (!response.data?.error && response.data?.permissionCategories) {
        // Criar objeto user atualizado com as novas permissionCategories
        const updatedUser = {
          ...user,
          permissionCategories: response.data.permissionCategories,
        };

        dispatch(refreshUserPermissions({ user: updatedUser }));
      }
    } catch (error) {
      console.error("Erro ao atualizar permissões:", error);
    }
  }, [token, user, dispatch]);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [eventModalOpen, setEventModalOpen] = useState(true); // Modal deve abrir inicialmente
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [listEvents, setListEvents] = useState([]);
  const [listYears, setListYears] = useState([]);

  // ✅ Hook para buscar contadores de documentos com atualização automática
  // Benefícios: ~10x mais rápido, polling para processos assíncronos, atualização automática
  const {
    counters: documentCounters,
    loading: loadingCounters,
    error: countersError,
    refetch: refetchCounters,
  } = useDocumentCounters(
    selectedEvent?.value, // eventId
    {}, // sem filtros (queremos todos os documentos do evento)
    {
      enabled: !!selectedEvent?.value, // só busca se tiver evento selecionado
      pollingInterval: 60000, // atualiza a cada 60s para capturar processos assíncronos do backend
    }
  );

  // Estado legado para manter compatibilidade com código existente
  const [apiCardsData, setApiCardsData] = useState(null);

  // Sincroniza contadores do hook com o estado legado
  useEffect(() => {
    if (documentCounters && !loadingCounters) {
      setApiCardsData({
        approvedCount: documentCounters.approvedCount || 0,
        pendingCount: documentCounters.pendingCount || 0,
        rejectedCount: documentCounters.rejectedCount || 0,
        awaitingCount: documentCounters.waitingSendCount || 0,
        dispensedCount: documentCounters.dispensedCount || 0,
      });
    }
  }, [documentCounters, loadingCounters]);

  const [objectDocument, setObjectDocument] = useState(
    initialStateObjectDocument
  );
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const intl = useIntl();
  const isSearching = useRef(false);
  const searchTimeoutRef = useRef(null);
  const permissionsLoadedForModalRef = useRef(false);
  const [documentOptions, setDocumentOptions] = useState([]);
  const [tableKey, setTableKey] = useState(1);
  const [statusFilter, setStatusFilter] = useState("");
  const [originFilter, setOriginFilter] = useState("");
  const [documentFilter, setDocumentFilter] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [clickButtonAction, setClickButtonAction] = useState(false);
  const [openChangeStatusModal, setOpenChangeStatusModal] = useState(false);
  const [documentToSwitchStatus, setDocumentToSwitchStatus] = useState(null);
  const [openModalSendFile, setOpenModalSendFile] = useState(false);
  const iconMap = {
    1: GoLinkExternal,
    2: FiMinus,
    3: IoCheckmark,
  };
  const textMap = {
    1: intl.formatMessage({ id: "approval_documents.open_file" }),
    2: intl.formatMessage({ id: "dispense_send" }),
    3: intl.formatMessage({ id: "make_mandatory" }),
  };
  const iconToUse = iconMap[tableKey];
  const textToUse = textMap[tableKey];
  const requestIdRef = useRef(0);

  const [documentId, setDocumentId] = useState(null);
  const [opportunityId, setOpportunityId] = useState(null);
  const [eventId, setEventId] = useState(null);
  const [documentName, setDocumentName] = useState("");
  const [allowedFileExtensions, setAllowedFileExtensions] = useState("");
  const [accountId, setAccountId] = useState(null);
  const [serviceProviderId, setServiceProviderId] = useState(null);
  const [flowName, setFlowName] = useState("");
  const [historyByDocument, setHistoryByDocument] = useState({});
  const [loadingHistory, setLoadingHistory] = useState({});
  const [openBulkUploadModal, setOpenBulkUploadModal] = useState(false);
  const [packageDocuments, setPackageDocuments] = useState([]);

  const havePermissionToUpload = useMemo(() => {
    return permission.includes("UPLOAD_THIRD_PARTY_DOCUMENTS");
  }, [permission]);

  const havePermissionToViewAwaitingAndDispensedDocuments = useMemo(() => {
    return permission.includes("VIEW_AWAITING_AND_DISPENSED_DOCUMENTS");
  }, [permission]);

  const havePermissionToDispenseAndRequireDocuments = useMemo(() => {
    return permission.includes("DISPENSE_AND_REQUIRE_DOCUMENTS");
  }, [permission]);
  const [packageDocsByRow, setPackageDocsByRow] = useState({});
  const [loadingPackageDocs, setLoadingPackageDocs] = useState({});
  const TABLE_KEY = { SENT: 1, AWAITING: 2, DISPENSED: 3 };

  const packageDocsByRowRef = useRef({});
  const loadingPackageDocsRef = useRef({});

  useEffect(() => {
    packageDocsByRowRef.current = packageDocsByRow;
  }, [packageDocsByRow]);

  useEffect(() => {
    loadingPackageDocsRef.current = loadingPackageDocs;
  }, [loadingPackageDocs]);

  useEffect(() => {
    setEventId(selectedEvent?.value ?? null);
  }, [selectedEvent, eventId, tableKey]);

  // ✅ Atualiza contadores ao mudar de aba (tableKey)
  // Garante que os números estejam atualizados ao navegar entre abas
  useEffect(() => {
    if (selectedEvent?.value && refetchCounters) {
      refetchCounters();
    }
  }, [tableKey, selectedEvent, refetchCounters]);

  const columns = useMemo(
    () => [
      {
        name: intl.formatMessage({ id: "approval_documents.flow_name" }),
        selector: (row) => row.flowName,
        cell: (row) => {
          const flowNameText = row.flowName || "";
          return (
            <Tooltip title={flowNameText} placement="topLeft">
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {flowNameText}
              </div>
            </Tooltip>
          );
        },
        sortable: true,
        left: true,
        grow: 2,
      },
      {
        name: intl.formatMessage({ id: "approval_documents.document" }),
        selector: (row) => row.fileName,
        cell: (row) => {
          const documentText =
            row.fileName === "document_package"
              ? intl.formatMessage({ id: "document_package" })
              : row.fileName || "";
          return (
            <Tooltip title={documentText} placement="topLeft">
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {documentText}
              </div>
            </Tooltip>
          );
        },
        sortable: true,
        left: true,
        grow: 2,
      },
      tableKey === 1 && {
        name: intl.formatMessage({ id: "approval_documents.company_type" }),
        selector: (row) => intl.formatMessage({ id: row.companyType }),
        cell: (row) => {
          const companyTypeText =
            intl.formatMessage({ id: row.companyType }) || "";
          return (
            <Tooltip title={companyTypeText} placement="topLeft">
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {companyTypeText}
              </div>
            </Tooltip>
          );
        },
        sortable: true,
        left: true,
        grow: 2,
      },
      {
        name: intl.formatMessage({ id: "approval_documents.company" }),
        selector: (row) => row.company || row.companyName,
        cell: (row) => {
          const companyText = row.company || row.companyName || "";
          return (
            <Tooltip title={companyText} placement="topLeft">
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {companyText}
              </div>
            </Tooltip>
          );
        },
        sortable: true,
        left: true,
        grow: 2,
      },
      {
        name: intl.formatMessage({ id: "approval_documents.contract" }),
        selector: (row) => row.contract || row.contractNumber,
        sortable: true,
        left: true,
        grow: 1,
      },

      tableKey === 3 && {
        name: intl.formatMessage({ id: "observations" }),
        selector: (row) => row.observation,
        cell: (row) => {
          const observationText = row.observation || "";
          return (
            <Tooltip title={observationText} placement="topLeft">
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {observationText}
              </div>
            </Tooltip>
          );
        },
        left: true,
        grow: 2,
      },
      tableKey === 1 && {
        name: intl.formatMessage({ id: "uploadOrigin" }),
        selector: (row) => row.uploadOrigin,
        cell: (row) => (
          <Tooltip
            title={intl.formatMessage({
              id: row.uploadOrigin ? row.uploadOrigin.toLowerCase() : "-",
            })}
            placement="topLeft"
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
            >
              {intl.formatMessage({
                id: row.uploadOrigin ? row.uploadOrigin.toLowerCase() : "-",
              })}
            </div>
          </Tooltip>
        ),
        sortable: true,
        left: true,
        grow: 1,
      },
      tableKey === 1 && {
        name: intl.formatMessage({ id: "approval_documents.status" }),
        selector: (row) => (tableKey === 1 ? row.status : row.contract),

        cell: (row) => {
          const canChangeStatus = ["APPROVED", "REJECTED"].includes(row.status);

          const defaultText = intl.formatMessage({
            id: row.status.toLowerCase(),
          });

          const hoverText =
            row.status === "APPROVED"
              ? intl.formatMessage({
                  id: "approval_documents.switch_rejected_option",
                })
              : row.status === "REJECTED"
              ? intl.formatMessage({
                  id: "approval_documents.switch_approved_option",
                })
              : "";

          return (
            <StatusDiv
              status={row.status}
              disabled={!canChangeStatus}
              data-hover={hoverText}
              onClick={() => {
                if (!canChangeStatus) return;
                setDocumentToSwitchStatus(row);
                setOpenChangeStatusModal(true);
              }}
            >
              <span>{defaultText}</span>
            </StatusDiv>
          );
        },
        sortable: true,
        center: true,
        grow: 2,
      },
      ...(tableKey === 2 && havePermissionToUpload
        ? [
            {
              cell: (row) => (
                <ButtonOpenPreview
                  bgColor="#E2E8F0"
                  textColor="#002244"
                  text={
                    row.items?.length > 0
                      ? intl.formatMessage({ id: "send_package" })
                      : intl.formatMessage({ id: "send_file" })
                  }
                  style={{ cursor: "pointer" }}
                  icon={FiPlus}
                  onClick={() =>
                    handleSendFile(
                      row.documentConfigId,
                      row.fileName,
                      row.opportunityId,
                      row.allowedFileExtensions,
                      row.accountId,
                      row.serviceProviderId,
                      row.flowName,
                      row.fileTypes,
                      row.items
                    )
                  }
                />
              ),
              grow: 2,
              right: true,
            },
          ]
        : []),
      {
        selector: (row) => row.status,
        cell: (row) => {
          if (row.purchasedThroughEcommerce) {
            return (
              <BtnInfo>
                <Tooltip
                  placement="left"
                  title={intl.formatMessage({
                    id: "document_purchase_ecommerce.info",
                  })}
                >
                  <BsInfoCircle size={22} />
                </Tooltip>
              </BtnInfo>
            );
          }

          // Se for tabela 2 e NÃO tiver permissão, não renderiza botão
          if (
            (tableKey === 2 || tableKey === 3) &&
            !havePermissionToDispenseAndRequireDocuments
          ) {
            return null;
          }

          // Se for documento fornecido pelo contrato (tableKey === 1), desabilitar botão
          const isProvidedByContract = tableKey === 1 && row.providedByContract;

          // Caso permitido
          const button = (
            <ButtonOpenPreview
              bgColor="#E2E8F0"
              textColor="#002244"
              text={textToUse}
              onClick={() => {
                if (isProvidedByContract) return; // Não fazer nada se desabilitado
                if (tableKey === 2 || tableKey === 3) {
                  setSelectedRows(row ? [row] : []);
                  setClearSelectedRows(true);
                  setClickButtonAction(true);
                  setConfirmationModalOpen(true);
                } else {
                  handleApproveReject(row);
                }
              }}
              style={{
                cursor: isProvidedByContract ? "not-allowed" : "pointer",
                opacity: isProvidedByContract ? 0.5 : 1,
              }}
              icon={iconToUse}
            />
          );

          // Se for fornecido pelo contrato, envolver em Tooltip
          if (isProvidedByContract) {
            return (
              <Tooltip
                placement="left"
                title={intl.formatMessage({
                  id: "document_provided_by_contract_cannot_open",
                })}
              >
                <span>{button}</span>
              </Tooltip>
            );
          }

          return button;
        },
        right: true,
        grow: 2,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      intl,
      tableKey,
      havePermissionToDispenseAndRequireDocuments,
      havePermissionToUpload,
      iconToUse,
      textToUse,
    ]
  );

  const columnPackage = useMemo(
    () => [
      {
        name: intl.formatMessage({ id: "approval_documents.document" }),
        selector: (row) => row.fileName,
        cell: (row) => {
          const documentText =
            row.fileName === "document_package"
              ? intl.formatMessage({ id: "document_package" })
              : row.fileName || "";
          return (
            <Tooltip title={documentText} placement="topLeft">
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {documentText}
              </div>
            </Tooltip>
          );
        },

        left: true,
        grow: 2,
      },
    ],

    [intl, tableKey, iconToUse, textToUse]
  );

  const isPackageRow = (row = {}) => Boolean(row.documentPackage);

  // Verifica se o delete está disponível: pacote só pode deletar se tiver ao menos 1 executionId
  const isDeleteAvailable = useMemo(() => {
    if (!objectDocument.documentPackage) return true;
    return (objectDocument.items ?? []).some((item) =>
      Boolean(item.documentExecutionId)
    );
  }, [objectDocument]);

  // Função para deletar documento pendente
  const handleDeletePendingDocument = async (row) => {
    try {
      setIsLoading(true);

      const isPackage = Boolean(row.documentPackage) && row.items?.length > 0;

      const documentIds = isPackage
        ? row.items.map((item) => item.documentExecutionId).filter(Boolean)
        : null;

      // Para pacote: path usa o primeiro documentExecutionId (representativo)
      // Para documento simples: path usa row.id (que já é o documentExecutionId)
      const pathId =
        isPackage && documentIds?.length > 0 ? documentIds[0] : row.id;

      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
        ...(documentIds?.length > 0 && { data: { documentIds } }),
      };

      await api.delete(`/upload-flow/documents/${pathId}`, config);

      notification.success({
        message: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({
          id: isPackage
            ? "approval_documents.delete_package_success"
            : "approval_documents.delete_document_success",
        }),
      });

      await reloadDocuments();
      cleanModalApproveReject();
    } catch (error) {
      const backendCode =
        error?.response?.data?.code || error?.response?.data?.errorCode;

      const errorMessageId =
        backendCode === -46016
          ? "approval_documents.staff_cannot_delete_others"
          : "approval_documents.delete_error";

      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({ id: errorMessageId }),
      });
    } finally {
      setIsLoading(false);
    }
  };

  const historyColumns = useMemo(
    () => [
      {
        name: intl.formatMessage({ id: "upload_date" }),
        selector: (row) => row.uploadDate,

        grow: 1,
        cell: (row) => (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            {dayjs(row.uploadDate).format("DD/MM/YYYY HH:mm")}
          </div>
        ),
      },

      {
        name: intl.formatMessage({ id: "uploadedBy" }),
        selector: (row) => row.uploadedBy,

        grow: 1,
      },
      {
        name: intl.formatMessage({ id: "uploadOrigin" }),
        selector: (row) => row.uploadOrigin,

        grow: 1,
        cell: (row) =>
          intl.formatMessage({
            id: row.uploadOrigin?.toLowerCase() || "-",
          }),
      },
      {
        name: intl.formatMessage({ id: "approval_documents.status" }),
        selector: (row) => row.status,

        center: true,
        grow: 1,
        cell: (row) => {
          const text = intl.formatMessage({
            id: row.status.toLowerCase(),
          });

          return (
            <StatusDiv disabled status={row.status}>
              {text}
            </StatusDiv>
          );
        },
      },
      {
        name: intl.formatMessage({ id: "rejection_reason" }),
        selector: (row) => row.rejectionReason,
        grow: 3,
        cell: (row) => {
          const text = row.rejectionReason || "-";

          return (
            <Tooltip title={text} placement="topLeft">
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {text}
              </div>
            </Tooltip>
          );
        },
      },
    ],
    [intl]
  );

  const statusOptions = useMemo(() => {
    const opts = [
      {
        label: intl.formatMessage({ id: "admin.documents.pending_approve" }),
        value: "PENDING",
      },
      {
        label: intl.formatMessage({ id: "approval_documents.approved_option" }),
        value: "APPROVED",
      },
      {
        label: intl.formatMessage({ id: "approval_documents.rejected_option" }),
        value: "REJECTED",
      },
      {
        label: intl.formatMessage({ id: "approved_by_system" }),
        value: "APPROVED_BY_SYSTEM",
      },
    ];
    // Ordena alfabeticamente pelo label, mas mantém "todos" sempre no topo
    const [allOpt, ...rest] = opts;
    rest.sort((a, b) => a.label.localeCompare(b.label, intl.locale));
    return [allOpt, ...rest];
  }, [intl]);

  const originOptions = useMemo(() => {
    const opts = [
      {
        label: intl.formatMessage({ id: "ecommerce" }),
        value: "ECOMMERCE",
      },
      {
        label: intl.formatMessage({ id: "partner" }),
        value: "PARTNER",
      },
      {
        label: intl.formatMessage({ id: "client" }),
        value: "CLIENT",
      },
      {
        label: intl.formatMessage({ id: "contract" }),
        value: "CONTRACT",
      },
    ];
    // Ordena alfabeticamente pelo label, mas mantém "todos" sempre no topo
    const [allOpt, ...rest] = opts;
    rest.sort((a, b) => a.label.localeCompare(b.label, intl.locale));
    return [allOpt, ...rest];
  }, [intl]);

  // Esquema de validação para os filtros
  const filterSchema = z.object({
    selectedDocuments: z
      .object({
        value: z.string(),
        label: z.string(),
      })
      .optional(),
    selectedStatus: z
      .object({
        value: z.string(),
        label: z.string(),
      })
      .optional(),
    selectedOrigin: z
      .object({
        value: z.string(),
        label: z.string(),
      })
      .optional(),
  });

  const form = useForm({
    resolver: zodResolver(filterSchema),
    mode: "onChange",
    defaultValues: {
      selectedDocuments: null,
      selectedStatus: null,
    },
  });

  const { reset } = form;
  const watchedDocuments = documentFilter === "all" ? null : documentFilter;
  const watchedStatus = statusFilter === "all" ? null : statusFilter;
  const watchedOrigin = originFilter === "all" ? null : originFilter;

  const headerRequest = useMemo(
    () => ({
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    }),
    [token]
  );

  const fetchDocuments = useCallback(
    async (
      page = 0,
      size = rowsPerPage,
      search = "",
      docFilter = documentFilter === "all" ? null : documentFilter,
      statsFilter = statusFilter === "all" ? null : statusFilter,
      originFiltered = originFilter === "all" ? null : originFilter,
      eventOverride = null,
      tableKeyOverride = tableKey,
      sortByOverride = sortBy,
      sortDirectionOverride = sortDirection
    ) => {
      const eventToUse = eventOverride || selectedEvent;
      if (!eventToUse?.value) return;

      const currentRequestId = ++requestIdRef.current;
      setIsLoading(true);

      try {
        let serviceToUse;

        switch (tableKeyOverride) {
          case 1:
            serviceToUse = getEventDocumentsService;
            break;
          case 2:
            serviceToUse = getNotDispensedDocumentsService;
            break;
          case 3:
            serviceToUse = getDispensedDocumentsService;
            break;
          default:
            serviceToUse = getEventDocumentsService;
        }

        const [response, responseDocumentConfigs] = await Promise.all([
          serviceToUse({
            eventId: eventToUse.value,
            page,
            size,
            search,
            document: docFilter,
            status: statsFilter,
            uploadOrigin: originFiltered,
            sortBy: sortByOverride,
            sortDirection: sortDirectionOverride,
            headers: headerRequest,
          }),
          getDocumentConfigsService(eventToUse.value),
        ]);

        // 🔐 Se essa não for a última requisição ativa, ignora
        if (currentRequestId !== requestIdRef.current) return;

        if (response.data) {
          const documents = response.data.documents || [];
          const total =
            response.data.totalElements ||
            response.data.totalItems ||
            response.data.total ||
            0;

          setFilteredData(documents);
          setTotalRows(total);

          const documentsList = responseDocumentConfigs.data?.output || [];

          setDocumentOptions(
            Array.isArray(documentsList)
              ? documentsList.map((document) => ({
                  label: document.label,
                  value: document.value,
                }))
              : []
          );
        }
      } catch (error) {
        if (currentRequestId !== requestIdRef.current) return;

        console.error("fetchDocuments error:", error);
        setApiCardsData(null);
        setFilteredData([]);
        setTotalRows(0);

        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: "api.error." + error.response?.data?.code,
          }),
        });
      } finally {
        if (currentRequestId === requestIdRef.current) {
          setIsLoading(false);
        }
      }
    },
    [
      selectedEvent,
      headerRequest,
      intl,
      rowsPerPage,
      sortBy,
      sortDirection,
      tableKey,
      statusFilter,
      documentFilter,
      originFilter,
    ]
  );

  const handleSelectedRowsChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
    setClickButtonAction(false);
  };

  const sendDispenseStatus = async (rows, observation) => {
    const body = rows.map((item) => ({
      documentConfigId: item.documentConfigId,
      systemUserId: item.systemUserId,
      opportunityId: item.opportunityId,
      accountId: item.accountId,
      serviceProviderId: item.serviceProviderId,
      observation: observation || "",
    }));

    const dispense = tableKey === 2 ? "true" : tableKey === 3 ? "false" : null;

    if (!dispense) {
      console.warn("Valor de dispense inválido para tableKey:", tableKey);
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      await postDispenseStatusService(body, dispense, headers);
      notification.success({
        message: intl.formatMessage({ id: "success" }),
        description: getDescriptionSuccessDispenseOrMandatory(tableKey, body),
      });
    } catch (error) {
      console.error("Erro ao enviar dispense:", error);
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({ id: "error" }),
      });
    } finally {
      setSelectedRows([]);
      setClickButtonAction(false);
      setClearSelectedRows(true); // Force clear table selection
      fetchDocuments();
      setConfirmationModalOpen(false);
      // ✅ Contadores atualizados automaticamente pelo hook após ação
      if (refetchCounters) {
        refetchCounters();
      }
    }
  };

  const performSearch = useCallback(
    (searchTerm) => {
      if (!selectedEvent) return;

      isSearching.current = true;

      // Capturar valores atuais dos filtros
      const currentDocumentValue =
        documentFilter === "all" ? null : documentFilter;
      const currentStatusValue = statusFilter === "all" ? null : statusFilter;
      const currentOriginValue = originFilter === "all" ? null : originFilter;

      setCurrentPage(1);
      fetchDocuments(
        0,
        rowsPerPage,
        searchTerm,
        currentDocumentValue,
        currentStatusValue,
        currentOriginValue
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      selectedEvent,
      watchedDocuments,
      watchedStatus,
      watchedOrigin,
      rowsPerPage,
      fetchDocuments,
    ]
  );

  const handleEventSelect = async (eventData) => {
    try {
      setSelectedEvent(eventData);
      setEventModalOpen(false);

      reset({
        selectedDocuments: null,
        selectedStatus: null,
      });

      setSearchTerm("");
      setCurrentPage(1);
      setSortBy("");
      setSortDirection("");

      // ✅ Contadores serão buscados automaticamente pelo hook quando selectedEvent mudar
      // Buscar documentos da primeira página
      await fetchDocuments(0, rowsPerPage, "", null, null, null, eventData);
    } catch (error) {
      console.error("handleEventSelect error:", error);
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({ id: "error" }),
      });
    }
  };

  const handleChangeEvent = () => {
    reset({
      selectedDocuments: null,
      selectedStatus: null,
      selectedOrigin: null,
    });

    setSearchTerm("");
    setApiCardsData(null);
    setFilteredData([]);
    setTotalRows(0);
    setCurrentPage(1);
    setSortBy("");
    setSortDirection("");

    setDocumentId(null);
    setOpportunityId(null);
    setEventId(null);
    setAccountId(null);
    setServiceProviderId(null);
    setFlowName("");

    setEventModalOpen(true);
  };

  const handleEventModalClose = () => {
    setEventModalOpen(false);
  };

  const handleApproveReject = (objectDoc) => {
    const locale = intl.locale;
    let dateSentUpload = "";

    if (locale === "en" || locale === "en-US")
      dateSentUpload =
        dayjs(objectDoc.fileSubmissionDate).format("M/D/YYYY") ?? "---";
    // [at] h:mm A
    else
      dateSentUpload =
        dayjs(objectDoc.fileSubmissionDate).format("DD/MM/YYYY") ?? "---"; // [às] HH:mm

    setObjectDocument({
      id: objectDoc.id ?? 0,
      urlForDownload: objectDoc.urlForDownload,
      urlForView: objectDoc.urlForView,
      title: objectDoc.fileName || "Documento",
      subtitle: objectDoc.company || "MMP Montagem e Locacao LTDA",
      dateText: dateSentUpload,
      status: objectDoc.status,
      justification: objectDoc.justification,
      observation: objectDoc.observation,
      executionObservation: objectDoc.executionObservation,
      uploadOrigin: objectDoc.uploadOrigin,
      rejectionReason: objectDoc.rejectionReason,
      items: objectDoc.items ?? [], // ← itens do pacote
      documentPackage: Boolean(objectDoc.documentPackage),
      flowName: objectDoc.flowName || "",
    });

    setPreviewOpen(true);
  };

  const cleanModalApproveReject = () => {
    setObjectDocument(initialStateObjectDocument);
    setPreviewOpen(false);
    setRejectModalOpen(false);
  };

  const reloadDocuments = async () => {
    if (!selectedEvent) return;

    try {
      const watchedDocumentValue =
        documentFilter === "all" ? null : documentFilter;
      const watchedStatusValue = statusFilter === "all" ? null : statusFilter;
      const watchedOriginValue = originFilter === "all" ? null : originFilter;

      await fetchDocuments(
        currentPage - 1,
        rowsPerPage,
        searchTerm,
        watchedDocumentValue,
        watchedStatusValue,
        watchedOriginValue
      );

      // ✅ Atualiza contadores após recarregar documentos
      // Garante que os números estejam sincronizados após ações (upload, aprovação, etc)
      if (refetchCounters) {
        refetchCounters();
      }
    } catch (error) {
      console.error("Error reloading documents:", error);
    }
  };

  const getPackageDocumentIds = useCallback(
    (docOverride = null) => {
      const doc = docOverride || objectDocument;
      return doc.documentPackage && doc.items?.length > 0
        ? {
            documentIds: doc.items.map((item) => item.documentExecutionId),
          }
        : {};
    },
    [objectDocument]
  );

  const handleApprove = async (justification) => {
    let approvalStatus = "APPROVED";
    if (documentToSwitchStatus) {
      // Só abre o segundo modal se status atual for APROVADO
      if (documentToSwitchStatus.status === "APPROVED") {
        setOpenChangeStatusModal(false);
        setJustificationForLog(justification);
        setObjectDocument((prev) => ({
          ...prev,
          id: documentToSwitchStatus.id,
          items: documentToSwitchStatus.items ?? [], // ← fix
          documentPackage: Boolean(documentToSwitchStatus.documentPackage),
        }));
        setRejectModalOpen(true);
        return;
      } else if (documentToSwitchStatus.status === "REJECTED") {
        approvalStatus = "APPROVED";
      }
    }
    try {
      setOpenChangeStatusModal(false);
      setIsLoading(true);
      const isStatusChange =
        !!documentToSwitchStatus &&
        documentToSwitchStatus.status !== approvalStatus;
      const sourceDocument = documentToSwitchStatus || objectDocument;

      const DocumentApproveOrRejectStatusRequest = {
        justification: justification || "",
        observation: "",
        approvalStatus: approvalStatus,
        statusChange: isStatusChange,
        ...(documentToSwitchStatus &&
        documentToSwitchStatus.status === "REJECTED" &&
        approvalStatus === "APPROVED"
          ? { justificationForLog: justification }
          : {}),
        ...getPackageDocumentIds(sourceDocument),
      };

      const response = await api.post(
        `/upload-flow/documents/${
          objectDocument.id ? objectDocument.id : documentToSwitchStatus.id
        }/review`,
        DocumentApproveOrRejectStatusRequest,
        headerRequest
      );

      if (response.status === 200) {
        let messageId = "document_approved_successfully";
        if (documentToSwitchStatus) {
          messageId =
            approvalStatus === "APPROVED"
              ? "document_approved_successfully"
              : "document_rejected_successfully";
        }

        notification.success({
          message: intl.formatMessage({ id: "success" }),
          description: intl.formatMessage({
            id: messageId,
          }),
        });

        cleanModalApproveReject();
        await reloadDocuments(); // Recarregar lista de documentos
      }
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + error.response.data.code,
        }),
      });

      console.error("Error approving document:", error);
    } finally {
      setIsLoading(false);
      setDocumentToSwitchStatus(null);
    }
  };

  const handleRejectClick = () => {
    setPreviewOpen(false);
    setRejectModalOpen(true);
  };

  const handleRejectConfirm = async (rejectData) => {
    try {
      setIsLoading(true);
      const isStatusChange =
        !!documentToSwitchStatus &&
        documentToSwitchStatus.status !== "REJECTED";
      const sourceDocument = documentToSwitchStatus || objectDocument;
      const DocumentApproveOrRejectStatusRequest = {
        rejectionReasonId: rejectData.rejectionReasonId,
        justification: rejectData.justification,
        observation: rejectData.observation || "",
        approvalStatus: "REJECTED",
        justificationForLog: justificationForLog,
        statusChange: isStatusChange,
        ...getPackageDocumentIds(sourceDocument),
      };

      const response = await api.post(
        `/upload-flow/documents/${objectDocument.id}/review`,
        DocumentApproveOrRejectStatusRequest,
        headerRequest
      );

      if (response.status === 200) {
        notification.success({
          message: intl.formatMessage({ id: "success" }),
          description: intl.formatMessage({
            id: "document_rejected_successfully",
          }),
        });

        cleanModalApproveReject();
        await reloadDocuments();
      }
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({ id: "error" }),
      });
      console.error("Error rejecting document:", error);
    } finally {
      setIsLoading(false);
      setDocumentToSwitchStatus(null); // ← limpa o estado após o fluxo APROVADO → REJEITADO
      setJustificationForLog("");
    }
  };

  const stats = useMemo(() => {
    if (!selectedEvent || apiCardsData === null) {
      return { approved: 0, pending: 0, rejected: 0, awaiting: 0 };
    }

    const approved = apiCardsData.approvedCount;
    const pending = apiCardsData.pendingCount;
    const rejected = apiCardsData.rejectedCount;
    const awaiting = apiCardsData.awaitingCount;
    const dispensed = apiCardsData.dispensedCount;

    return { approved, pending, rejected, awaiting, dispensed };
  }, [selectedEvent, apiCardsData]);

  // useEffect para recarregar permissões APENAS UMA VEZ quando o modal abrir
  useEffect(() => {
    if (previewOpen && !permissionsLoadedForModalRef.current) {
      permissionsLoadedForModalRef.current = true;
      refreshPermissions();
    } else if (!previewOpen) {
      // Resetar flag quando o modal fechar para permitir nova carga na próxima abertura
      permissionsLoadedForModalRef.current = false;
    }
  }, [previewOpen, refreshPermissions]);

  // useEffect para filtros - chama a API quando os filtros mudam (mas NÃO searchTerm ou selectedEvent inicial)
  useEffect(() => {
    if (!selectedEvent) {
      setFilteredData([]);
      setTotalRows(0);
      return;
    }

    if (isSearching.current) return;
    const watchedDocuments = documentFilter === "all" ? null : documentFilter;
    const watchedStatus = statusFilter === "all" ? null : statusFilter;
    const watchedOrigin = originFilter === "all" ? null : originFilter;

    // Se não há filtros aplicados, não disparar
    if (!documentFilter && !statusFilter && !originFilter) return;

    setCurrentPage(1);

    fetchDocuments(
      0,
      rowsPerPage,
      "",
      watchedDocuments,
      watchedStatus,
      watchedOrigin
    );
  }, [
    documentFilter,
    statusFilter,
    originFilter,
    selectedEvent,
    fetchDocuments,
    rowsPerPage,
    tableKey,
  ]);

  // useEffect separado para busca com debounce (APENAS para searchTerm)
  useEffect(() => {
    if (!selectedEvent) return;

    // Se searchTerm estiver vazio, limpar flag de busca e não fazer nada
    if (!searchTerm || searchTerm.trim() === "") {
      isSearching.current = false;
      return;
    }

    // Limpar timeout anterior se existir
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      performSearch(searchTerm);
    }, 500); // debounce de 500ms para pesquisa

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchTerm, selectedEvent, performSearch]);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      const watchedDocumentValue =
        documentFilter === "all" ? null : documentFilter;
      const watchedStatusValue = statusFilter === "all" ? null : statusFilter;
      const watchedOriginValue = originFilter === "all" ? null : originFilter;
      fetchDocuments(
        page - 1,
        rowsPerPage,
        searchTerm,
        watchedDocumentValue,
        watchedStatusValue,
        watchedOriginValue
      );
    },
    [
      fetchDocuments,
      rowsPerPage,
      searchTerm,
      documentFilter,
      statusFilter,
      originFilter,
    ]
  );

  const handlePerRowsChange = useCallback(
    (newRowsPerPage, page) => {
      setRowsPerPage(newRowsPerPage);
      setCurrentPage(page);
      const watchedDocumentValue =
        documentFilter === "all" ? null : documentFilter;
      const watchedStatusValue = statusFilter === "all" ? null : statusFilter;
      const watchedOriginValue = originFilter === "all" ? null : originFilter;
      fetchDocuments(
        page - 1,
        newRowsPerPage,
        searchTerm,
        watchedDocumentValue,
        watchedStatusValue,
        watchedOriginValue
      );
    },
    [fetchDocuments, searchTerm, watchedDocuments, watchedStatus, watchedOrigin] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const handleSortChange = useCallback(
    (column, newSortDirection) => {
      if (sortBy === column.id && sortDirection === newSortDirection) {
        return;
      }

      setSortBy(column.id);
      setSortDirection(newSortDirection);
      const watchedDocumentValue =
        documentFilter === "all" ? null : documentFilter;
      const watchedStatusValue = statusFilter === "all" ? null : statusFilter;
      const watchedOriginValue = originFilter === "all" ? null : originFilter;
      fetchDocuments(
        currentPage - 1,
        rowsPerPage,
        searchTerm,
        watchedDocumentValue,
        watchedStatusValue,
        watchedOriginValue,
        null,
        tableKey,
        column.id,
        newSortDirection
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      fetchDocuments,
      currentPage,
      rowsPerPage,
      searchTerm,
      watchedDocuments,
      watchedStatus,
      watchedOrigin,
      sortBy,
      sortDirection,
    ]
  );

  const handleSearchChange = (e) => {
    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);

    // Se o search foi limpo, buscar imediatamente (sem debounce)
    if (!newSearchTerm || newSearchTerm.trim() === "") {
      isSearching.current = false;
      const selectedDocumentValue =
        documentFilter === "all" ? null : documentFilter;
      const selectedStatusValue = statusFilter === "all" ? null : statusFilter;
      const selectedOriginValue = originFilter === "all" ? null : originFilter;
      setCurrentPage(1);
      fetchDocuments(
        0,
        rowsPerPage,
        "",
        selectedDocumentValue,
        selectedStatusValue,
        selectedOriginValue
      );
    }
    // O useEffect com debounce cuidará da busca para termos não vazios
  };

  const getYears = useCallback(() => {
    getReportFilterYearsService({ token })
      .then((result) => {
        setListYears(
          (result.data?.output ?? []).map((year) => ({
            label: String(year),
            value: year,
          }))
        );
      })
      .catch(() => {
        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({ id: "error" }),
        });
      });
  }, [token, intl]);

  const getEventsByYear = useCallback(
    (year) => {
      setListEvents([]);

      if (year === null || year === undefined) {
        return;
      }

      getReportFilterEventsByYearService({ token, year })
        .then((result) => {
          const transformedEvents = (result.data?.output ?? []).map((event) => ({
            label: event.eventEditionName,
            value: event.idNumber,
          }));

          let eventsSort = [...transformedEvents].sort((a, b) =>
            a.label < b.label ? -1 : a.label > b.label ? 1 : 0
          );

          setListEvents(eventsSort);
        })
        .catch(() => {
          notification.error({
            message: intl.formatMessage({ id: "error" }),
            description: intl.formatMessage({ id: "error" }),
          });
        });
    },
    [token, intl]
  );

  useEffect(() => {
    getYears();
  }, [getYears]);

  useEffect(() => {
    if (clearSelectedRows) {
      const timer = setTimeout(() => {
        setClearSelectedRows(false);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [clearSelectedRows]);

  const getDescriptionForConfirmationModalDispenseOrmandatory = (
    tableKey,
    selectedRows
  ) => {
    switch (true) {
      case tableKey === 2 && selectedRows.length > 1:
        return intl.formatMessage({ id: "remove_contracts_exempt_exemption" });

      case tableKey === 2 && selectedRows.length === 1:
        return intl.formatMessage({
          id: "remove_contracts_exempt_exemption_single",
        });

      case tableKey !== 2 && selectedRows.length > 1:
        return intl.formatMessage({ id: "remove_contracts_removed_exemption" });

      case tableKey !== 2 && selectedRows.length === 1:
        return intl.formatMessage({
          id: "remove_contracts_removed_exemption_single",
        });

      default:
        if (tableKey === 2)
          return intl.formatMessage({
            id: "remove_contracts_exempt_exemption",
          });
        else
          return intl.formatMessage({
            id: "remove_contracts_removed_exemption",
          });
    }
  };

  const getDescriptionSuccessDispenseOrMandatory = (tableKey, selectedRows) => {
    switch (true) {
      case tableKey === 2 && selectedRows.length > 1:
        return intl.formatMessage({ id: "success_dispense" });

      case tableKey === 2 && selectedRows.length === 1:
        return intl.formatMessage({
          id: "success_dispense_single",
        });

      case tableKey !== 2 && selectedRows.length > 1:
        return intl.formatMessage({ id: "success_mandatory" });

      case tableKey !== 2 && selectedRows.length === 1:
        return intl.formatMessage({
          id: "success_mandatory_single",
        });

      default:
        if (tableKey === 2)
          return intl.formatMessage({ id: "success_dispense" });
        else return intl.formatMessage({ id: "success_mandatory" });
    }
  };

  const normalizeExtensions = (value) => {
    if (!value) return "";
    if (Array.isArray(value)) return value.join(", ");
    return String(value);
  };

  const handleSendFile = useCallback(
    (
      documentConfigId,
      fileName,
      opportunityId,
      allowedFileExtensions,
      accountId,
      serviceProviderId,
      flowName,
      fileTypes,
      items
    ) => {
      const isPackageUpload = Array.isArray(items) && items.length > 0;
      const rawExtensions = isPackageUpload
        ? items[0]?.fileTypes
        : allowedFileExtensions || fileTypes;
      setServiceProviderId(serviceProviderId);
      setAccountId(accountId);
      setAllowedFileExtensions(normalizeExtensions(rawExtensions));
      setDocumentId(documentConfigId);
      setDocumentName(fileName);
      setOpportunityId(opportunityId);
      setFlowName(flowName || fileName);
      setPackageDocuments(items ?? []);
      setOpenModalSendFile(true);
    },
    [selectedEvent]
  );

  const handleExpand = async (expanded, row) => {
    if (!expanded) return;
    if (historyByDocument[row.id]) return;
    if (loadingHistory[row.id]) return;

    // evita refetch
    if (historyByDocument[row.id]) return;

    setLoadingHistory((prev) => ({
      ...prev,
      [row.id]: true,
    }));

    try {
      const response = await getDocumentResendHistory(row.id);

      if (!response || response.error) {
        // salva vazio para evitar loop de requisição
        setHistoryByDocument((prev) => ({
          ...prev,
          [row.id]: [],
        }));
        return;
      }

      setHistoryByDocument((prev) => ({
        ...prev,
        [row.id]: response.data.history || [],
      }));
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + error.response.data.code,
        }),
      });

      setHistoryByDocument((prev) => ({
        ...prev,
        [row.id]: [],
      }));
    } finally {
      setLoadingHistory((prev) => ({
        ...prev,
        [row.id]: false,
      }));
    }
  };

  const ExpandedComponent = ({ data }) => {
    const history = historyByDocument[data.id] || [];
    const isLoading = loadingHistory[data.id];

    return (
      <div
        style={{
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",

          margin: "8px 16px",
        }}
      >
        <Table
          data={history}
          columns={historyColumns}
          pagination={false}
          progressPending={isLoading}
          highlightOnHover={false}
          dense
        />
      </div>
    );
  };

  const handleExpandPackage = useCallback(
    async (expanded, row) => {
      if (!expanded) return;

      const cacheKey = row.idExecution
        ? `${row.id}_${row.idExecution}`
        : String(row.id);

      if (packageDocsByRowRef.current[cacheKey]) return;
      if (loadingPackageDocsRef.current[cacheKey]) return;

      setLoadingPackageDocs((prev) => ({ ...prev, [cacheKey]: true }));

      try {
        const data = await fetchPackageInternalDocuments({
          eventId: selectedEvent?.value,
          uploadFlowId: row.uploadFlowId,
          token,
          params: {
            opportunityId: row.opportunityId,
            ...(row.idExecution && { executionId: row.idExecution }),
          },
        });

        const list = Array.isArray(data) ? data : data?.documents ?? [];
        setPackageDocsByRow((prev) => ({ ...prev, [cacheKey]: list }));
      } catch (error) {
        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: "expanded_documents.fetch_error",
          }),
        });
        setPackageDocsByRow((prev) => ({ ...prev, [cacheKey]: [] }));
      } finally {
        setLoadingPackageDocs((prev) => ({ ...prev, [cacheKey]: false }));
      }
    },
    [selectedEvent, token, intl]
  );

  const ExpandedPackageComponent = ({ data }) => {
    const cacheKey = data.idExecution
      ? `${data.id}_${data.idExecution}`
      : String(data.id);

    const docs = packageDocsByRow[cacheKey] || [];
    const loading = loadingPackageDocs[cacheKey];

    return (
      <div
        style={{
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",
          margin: "8px 16px",
        }}
      >
        <Table
          data={docs}
          columns={columnPackage}
          pagination={false}
          progressPending={loading}
          highlightOnHover={false}
          dense
        />
      </div>
    );
  };

  return (
    <>
      {/* Modal do envio de documentos */}
      <AdminSendFileModal
        visible={openModalSendFile}
        documentId={documentId}
        documentName={documentName}
        opportunityId={opportunityId}
        eventId={eventId}
        allowedFileExtensions={allowedFileExtensions}
        accountId={accountId}
        serviceProviderId={serviceProviderId}
        flowName={flowName}
        packageDocuments={packageDocuments}
        thirdPartyUpload={tableKey === 2}
        onFinish={({ success } = {}) => {
          setOpenModalSendFile(false);

          // 🔥 limpa tudo
          setDocumentId(null);
          setOpportunityId(null);
          setEventId(null);
          setAccountId(null);
          setServiceProviderId(null);
          setFlowName("");

          if (success) reloadDocuments();
        }}
      />

      <AdminSendFileModal
        visible={openBulkUploadModal}
        eventId={eventId}
        isBulkUpload={true}
        allowedFileExtensions={".xlsx"}
        thirdPartyUpload={tableKey === 2}
        selectEvent={selectedEvent?.value}
        onFinish={({ success } = {}) => {
          setOpenBulkUploadModal(false);
          if (success) reloadDocuments();
        }}
      />
      {/*  */}
      <AnimatedMainContainer>
        <AreaBreadcrumbWithEvent>
          <BreadcrumbText>
            {intl.formatMessage({ id: "sidebar.upload_documents" })} |
            {intl.formatMessage({ id: "sidebar.document_approval" })} -
          </BreadcrumbText>

          {selectedEvent ? (
            <TitleContainer onClick={handleChangeEvent}>
              <Title style={{ cursor: "pointer" }}>
                {selectedEvent?.label}
              </Title>
              <HiOutlinePencil
                size={16}
                color="#002244"
                style={{ cursor: "pointer" }}
              />
            </TitleContainer>
          ) : (
            <TitleContainer>
              <Title style={{ cursor: "pointer" }} onClick={handleChangeEvent}>
                {intl.formatMessage({ id: "choose_event" })}
              </Title>
              <HiOutlinePencil
                size={16}
                color="#002244"
                style={{ cursor: "pointer" }}
              />
            </TitleContainer>
          )}
        </AreaBreadcrumbWithEvent>

        <SelectDropdownStyles
          style={{ width: "100%" }}
          dropdownMatchSelectWidth
        />

        {/* Cards de Estatísticas */}
        <StatsCardsContainer>
          <StatsCard type="APPROVED">
            <StatsCardTitle>
              <FormattedMessage
                id="admin_approved_documents"
                defaultMessage="APROVADOS"
              />
            </StatsCardTitle>
            <StatsCardNumber data-test="approved-documents-count">
              {stats.approved}
            </StatsCardNumber>
          </StatsCard>

          <StatsCard type="PENDING">
            <StatsCardTitle>
              <FormattedMessage
                id="admin.documents.box_pending_approve"
                defaultMessage="PENDENTES DE APROVAÇÃO"
              />
            </StatsCardTitle>
            <StatsCardNumber data-test="pending-documents-count">
              {stats.pending}
            </StatsCardNumber>
          </StatsCard>

          <StatsCard type="REJECTED">
            <StatsCardTitle>
              <FormattedMessage
                id="admin_rejected_documents"
                defaultMessage="REPROVADOS"
              />
            </StatsCardTitle>

            <StatsCardNumber data-test="rejected-documents-count">
              {stats.rejected}
            </StatsCardNumber>
          </StatsCard>
          <StatsCard type="AWAITING">
            <StatsCardTitle>
              <FormattedMessage
                id="awaiting_send"
                defaultMessage="AGUARDANDO ENVIO"
              />
            </StatsCardTitle>
            <StatsCardNumber data-test="awaiting-documents-count">
              {stats.awaiting || 0}
            </StatsCardNumber>
          </StatsCard>
          <StatsCard type="AWAITING">
            <StatsCardTitle>
              <FormattedMessage id="dispensed" defaultMessage="DISPENSADOS" />
            </StatsCardTitle>
            <StatsCardNumber data-test="dispensed-documents-count">
              {stats.dispensed || 0}
            </StatsCardNumber>
          </StatsCard>
        </StatsCardsContainer>

        <Container>
          <HeaderContainer>
            <TabsAndFilterContainer>
              <TableTab
                data-test="documents-sent"
                style={{
                  borderTopLeftRadius: "4px",
                  borderBottomLeftRadius: "4px",
                  borderTopRightRadius: "0px",
                  borderBottomRightRadius: "0px",
                }}
                active={tableKey === 1}
                onClick={() => {
                  if (isLoading) return;
                  setTableKey(1);
                  setSelectedRows([]);
                  setClickButtonAction(false);
                  setClearSelectedRows(true);
                  fetchDocuments(0, rowsPerPage, "", null, null, null, null, 1);
                }}
              >
                {`${intl.formatMessage({ id: "documents_sent" })} ${
                  tableKey === 1 && !isLoading ? "(" + totalRows + ")" : ""
                }`}
              </TableTab>

              {havePermissionToViewAwaitingAndDispensedDocuments && (
                <>
                  <TableTab
                    data-test="awaiting-send-documents"
                    style={{ borderRadius: "0px" }}
                    active={tableKey === 2}
                    onClick={() => {
                      if (isLoading) return;
                      setTableKey(2);
                      setSelectedRows([]);
                      setClickButtonAction(false);
                      setClearSelectedRows(true);
                      fetchDocuments(
                        0,
                        rowsPerPage,
                        "",
                        null,
                        null,
                        null,
                        null,
                        2
                      );
                    }}
                  >
                    {`${intl.formatMessage({ id: "awaiting_send" })} ${
                      tableKey === 2 && !isLoading ? "(" + totalRows + ")" : ""
                    }`}
                  </TableTab>
                  <TableTab
                    data-test="dispensed-documents"
                    style={{
                      borderTopLeftRadius: "0px",
                      borderBottomLeftRadius: "0px",
                      borderTopRightRadius: "4px",
                      borderBottomRightRadius: "4px",
                    }}
                    active={tableKey === 3}
                    onClick={() => {
                      if (isLoading) return;
                      setTableKey(3);
                      setSelectedRows([]);
                      setClickButtonAction(false);
                      setClearSelectedRows(true);
                      fetchDocuments(
                        0,
                        rowsPerPage,
                        "",
                        null,
                        null,
                        null,
                        null,
                        3
                      );
                    }}
                  >
                    {`${intl.formatMessage({ id: "disregarded" })} ${
                      tableKey === 3 && !isLoading ? "(" + totalRows + ")" : ""
                    }`}
                  </TableTab>
                </>
              )}

              <SelectsFilterContainer>
                <SelectWithInternalLabel
                  label={
                    intl.formatMessage({
                      id: "documents",
                    }) + ":"
                  }
                  options={documentOptions}
                  value={documentFilter}
                  onChange={setDocumentFilter}
                  searchable
                />
                {tableKey === 1 && (
                  <SelectWithInternalLabel
                    label={intl.formatMessage({ id: "status" }) + ":"}
                    options={statusOptions}
                    value={statusFilter}
                    onChange={setStatusFilter}
                  />
                )}
                {tableKey === 1 && (
                  <SelectWithInternalLabel
                    label={intl.formatMessage({ id: "origin" }) + ":"}
                    options={originOptions}
                    value={originFilter}
                    onChange={setOriginFilter}
                  />
                )}
              </SelectsFilterContainer>
            </TabsAndFilterContainer>

            <SearchTableInput
              placeholder={intl.formatMessage({
                id: "search_by_flow_doc_company_contract",
              })}
              prefix={<HiOutlineMagnifyingGlass color="#1E293B" />}
              value={searchTerm}
              onChange={handleSearchChange}
            />
            {tableKey === 2 && (
              <TopActionButton
                data-test="mass-upload-button"
                onClick={() => setOpenBulkUploadModal(true)}
              >
                <FiUpload size={18} />
                {intl.formatMessage({ id: "bulk_upload" })}
              </TopActionButton>
            )}

            {tableKey !== 1 && (
              <TopActionButton
                disabled={selectedRows.length === 0}
                onClick={() => setConfirmationModalOpen(true)}
              >
                {tableKey === 2
                  ? intl.formatMessage({ id: "dispense_multiples" })
                  : intl.formatMessage({ id: "make_mandatory" })}
              </TopActionButton>
            )}
          </HeaderContainer>

          <RoundedTableContainer>
            {selectedEvent ? (
              <Table
                data={filteredData}
                columns={columns}
                progressPending={isLoading}
                paginationServer={true}
                paginationTotalRows={totalRows}
                paginationDefaultPage={currentPage}
                paginationPerPage={rowsPerPage}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                onSorted={handleSortChange}
                selectableRows={tableKey !== TABLE_KEY.SENT}
                onSelectedRowsChange={handleSelectedRowsChange}
                clearSelectedRows={clearSelectedRows}
                expandableRows={tableKey !== TABLE_KEY.DISPENSED}
                expandableRowsComponent={
                  tableKey === TABLE_KEY.SENT
                    ? ExpandedComponent
                    : tableKey === TABLE_KEY.AWAITING
                    ? ExpandedPackageComponent
                    : null
                }
                onRowExpandToggled={
                  tableKey === TABLE_KEY.AWAITING
                    ? handleExpandPackage
                    : handleExpand
                }
                expandableRowDisabled={(row) =>
                  tableKey === TABLE_KEY.AWAITING
                    ? !isPackageRow(row)
                    : !row.resent
                }
              />
            ) : (
              <div
                style={{
                  padding: "40px",
                  textAlign: "center",
                  color: "#6b7280",
                  fontSize: "16px",
                }}
              >
                <FormattedMessage
                  id="approval_documents.no_event_selected"
                  defaultMessage="Selecione um evento para visualizar os documentos de aprovação."
                />
              </div>
            )}
          </RoundedTableContainer>

          <QuickPreviewModal
            open={previewOpen}
            onClose={() => cleanModalApproveReject()}
            onApprove={() => {
              handleApprove();
            }}
            onReject={() => {
              handleRejectClick();
            }}
            onDelete={
              isDeleteAvailable
                ? () => handleDeletePendingDocument(objectDocument)
                : undefined
            }
            isStaff={isStaff}
            hasPermissionToDeleteOwnDocuments={
              hasPermissionToDeleteOwnDocuments
            }
            id={objectDocument.id}
            urlForDownload={objectDocument.urlForDownload}
            urlForView={objectDocument.urlForView}
            title={objectDocument.title}
            subtitle={objectDocument.subtitle}
            dateText={objectDocument.dateText}
            status={objectDocument.status}
            justification={objectDocument.justification}
            executionObservation={objectDocument.executionObservation}
            observation={objectDocument.observation}
            uploadOrigin={objectDocument.uploadOrigin}
            rejectionReason={objectDocument.rejectionReason}
            items={objectDocument.items}
            documentPackage={objectDocument.documentPackage}
            flowName={objectDocument.flowName}
          />

          <RejectDocumentModal
            isPackage={objectDocument.documentPackage === true}
            open={rejectModalOpen}
            onClose={cleanModalApproveReject}
            onGoBack={cleanModalApproveReject}
            onConfirm={handleRejectConfirm}
            loading={isLoading}
          />

          <EventSelectionModal
            isOpen={eventModalOpen}
            onClose={handleEventModalClose}
            onEventSelect={handleEventSelect}
            events={listEvents ?? []}
            years={listYears ?? []}
            onYearSelect={getEventsByYear}
            loading={isLoading}
          />
        </Container>
      </AnimatedMainContainer>

      <ConfirmationModal
        withInput
        inputPlaceholder={intl.formatMessage({
          id: "type_the_comment",
        })}
        setIsOpen={setConfirmationModalOpen}
        modalIsOpen={confirmationModalOpen}
        confirmationFunction={(observation) =>
          sendDispenseStatus(selectedRows, observation)
        }
        description={getDescriptionForConfirmationModalDispenseOrmandatory(
          tableKey,
          selectedRows
        )}
        confirmationText={intl.formatMessage({ id: "confirm" })}
        cancelText={intl.formatMessage({ id: "cancel" })}
        cancelationFunction={() => {
          if (clickButtonAction) {
            setSelectedRows([]);
            setClearSelectedRows(true);
            setConfirmationModalOpen(false);
            setClickButtonAction(false);
          }
        }}
      />

      <ConfirmationModal
        withInput
        InputIsObrigatory
        inputPlaceholder={intl.formatMessage({
          id: "justification_required",
        })}
        setIsOpen={setOpenChangeStatusModal}
        modalIsOpen={openChangeStatusModal}
        confirmationFunction={(justification) => handleApprove(justification)}
        description={intl.formatMessage({
          id: "switch_document_status",
        })}
        confirmationText={intl.formatMessage({ id: "confirm" })}
        cancelText={intl.formatMessage({ id: "cancel" })}
        cancelationFunction={() => {
          if (clickButtonAction) {
            setOpenChangeStatusModal(false);
          }
        }}
      />
    </>
  );
};

export default ApprovalDocuments;
